// @flow @format
import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from '../../../../components/Icon/circle-o-notch';
import classNames from 'lib/classnames';
import './Loading.css';

type Props = {
	className?: string,
	title: string,
};

const FilesLoading = ({title, className = ''}: Props) =>
	<div className={classNames('FilesLoading', className)}>
		<LoadingIcon className="FilesLoading__Spinner" />
		<p className="FilesLoading__Label">{title}</p>
	</div>;

FilesLoading.propTypes = {
	clasName: PropTypes.number,
	title: PropTypes.string.isRequired,
};

FilesLoading.defaultProps = {
	className: '',
};

export default FilesLoading;



// WEBPACK FOOTER //
// ./src/routes/Explorer/components/Loading/Loading.js